__turbopack_context__.v({
  "card": "jetPricing-module-scss-module__XvqaGG__card",
  "cardImg": "jetPricing-module-scss-module__XvqaGG__cardImg",
  "cardImgContainer": "jetPricing-module-scss-module__XvqaGG__cardImgContainer",
  "cardPriceNote": "jetPricing-module-scss-module__XvqaGG__cardPriceNote",
  "cardPriceTitle": "jetPricing-module-scss-module__XvqaGG__cardPriceTitle",
  "cardPriceWrapper": "jetPricing-module-scss-module__XvqaGG__cardPriceWrapper",
  "cardTitle": "jetPricing-module-scss-module__XvqaGG__cardTitle",
  "cardWrapper": "jetPricing-module-scss-module__XvqaGG__cardWrapper",
  "plainNameOverlay": "jetPricing-module-scss-module__XvqaGG__plainNameOverlay",
});
